import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0541b27c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mail-dialog"
}
const _hoisted_2 = { class: "head g-flex-al-center g-flex-jc-between" }
const _hoisted_3 = { class: "g-f18 g-fw7" }
const _hoisted_4 = { class: "status g-flex-al-center" }
const _hoisted_5 = { class: "infinite-list" }
const _hoisted_6 = { class: "message g-flex-al-center" }
const _hoisted_7 = { class: "avatar" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "info g-mt10 g-ml15" }
const _hoisted_10 = { class: "title g-f14" }
const _hoisted_11 = { class: "time g-f12" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "g-f14 g-mt10 g-mb10 text-center"
}
const _hoisted_14 = { class: "noMore" }
const _hoisted_15 = {
  key: 0,
  class: "g-f14 g-mt10 g-mb10 text-center"
}

import { ElIcon } from "element-plus";
import emptyUrl from '@/assets/operate/no_data.png';
import { Message, CloseBold } from "@element-plus/icons-vue";
import noticeType01 from "@/assets/operate/feedback/noticeType-01.png";
import noticeType02 from "@/assets/operate/feedback/noticeType-02.png";
import noticeType03 from "@/assets/operate/feedback/noticeType-03.png";
import noticeType04 from "@/assets/operate/feedback/noticeType-04.png";
import noticeType05 from "@/assets/operate/feedback/noticeType-05.png";
import { onMounted, ref, computed } from "vue";
import {
  getNoticeDel,
  getNoticeList,
  getNoticeUnread,
  noticeItemType,
  getNoticeAllRead,
} from "@/api/request/survey";
import { upgradeAccount } from "@/utils";
import { getDictList } from "@/api/request";
import Tea from "@dp/byted-tea-sdk-oversea";

import scrollArea from "@/components/scrollArea.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SiteMail',
  props: {
  showVisitorSurvey: {
    type: Function,
    required: false,
  },
},
  setup(__props) {

const $props = __props;

const avatars = [
  noticeType01,
  noticeType01,
  noticeType02,
  noticeType03,
  noticeType04,
  noticeType05,
  noticeType05,
  noticeType05,
  noticeType04,
  noticeType04,
  noticeType04,
  noticeType01,
];

function goCourse(item: noticeItemType) {
  if (
    item.noticeType === 1 ||
    item.noticeType === 2 ||
    item.noticeType === 3 ||
    item.noticeType === 4 ||
    item.noticeType === 5 ||
    item.noticeType === 12
  ) {
    Tea.event("site_mail_click", {
      client: "PC",
      source: "course",
      index: item.noticeType,
    });
    // 课程相关站内信跳转操作
    window.open(
      window.location.origin + "/operate/courseContent?id=" + item.jumpUrl
    );
  }
  if (
    item.noticeType === 6 ||
    item.noticeType === 7 ||
    item.noticeType === 8 ||
    item.noticeType === 11
  ) {
    Tea.event("site_mail_click", {
      client: "PC",
      source: "certificate",
      index: item.noticeType,
    });
    // 人才认证相关站内信跳转操作
    window.open(window.location.origin + "/operate/certification");
  }
  if (item.noticeType === 9 || item.noticeType === 10) {
    // 代理商信息完善相关站内信跳转操作
    getDictList({ type: "class_flag_id" }).then((res) => {
      let successId = [] as string[];
      res.data.forEach((item) => {
        successId.push(item.value);
      });
      Tea.event("site_mail_click", {
        client: "PC",
        source: "agent",
        index: item.noticeType,
      });
      window.open(
        window.location.origin + "/operate/course?classId=" + successId[0]
      );
    });
  }
}

function delItem(item: noticeItemType, index: number) {
  getNoticeDel({ businessId: item.businessId }).then(() => {
    mailList.value.splice(index, 1);
  });
}

const isShow = ref(false);
const mailList = ref([] as noticeItemType[]);
// 没有更多了
const noMore = ref(false);
const disabled = computed(() => {
  return noMore.value || loading.value;
});
const page = ref(1);
const size = ref(10);
const total = ref(0);
const loading = ref(false);
// 清除未读
function clearUnRead() {
  getNoticeAllRead().then(() => {
    isUnRead.value = false;
  });
}
function close() {
  isShow.value = false;
}



async function openDialog() {
  //if (upgradeAccount()) return;
  let {status} = await upgradeAccount();
  if(status === 'confirm'){
    $props.showVisitorSurvey && $props.showVisitorSurvey('confirm');
    return
  }  
  if(status === 'cancel' || status === 'close'){ 
    return
  }

  if (isShow.value) return;
  isShow.value = true;
  mailList.value = [];
  page.value = 1;
  noMore.value = false;
  getList();
}
function load() {
  console.log("加载下一页");
  page.value++;
  getList();
}
function getList() {
  console.log("加载内容");
  loading.value = true;
  getNoticeList({ page: page.value, size: size.value })
    .then((res) => {
      res.data.records.map((item) => {
        item.noticeContent = item.noticeContent.replaceAll("\\n", "\n");
      });
      mailList.value = mailList.value.concat(res.data.records);
      total.value = res.data.total;
      if (mailList.value.length >= total.value) noMore.value = true;
      getUnReadNum();
    })
    .finally(() => {
      loading.value = false;
    });
}
// 是否有未读信息
const isUnRead = ref(false);
const isUnReadNum = ref(0);
onMounted(() => {
  getUnReadNum();
});
function getUnReadNum() {
  getNoticeUnread().then((res) => {
    isUnRead.value = !!res.data;
    isUnReadNum.value = res.data;
  });
}

return (_ctx: any,_cache: any) => {
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", {
    class: "siteMail",
    tabindex: "-1",
    onBlur: _cache[2] || (_cache[2] = ($event: any) => (close()))
  }, [
    _createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: _ctx.$t('站内信'),
      placement: "left"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "icon g-flex-jc-center g-flex-al-center g-pointer",
          onClick: openDialog
        }, [
          _createVNode(_component_el_badge, {
            value: isUnReadNum.value,
            hidden: isUnReadNum.value === 0 ? true : false,
            class: "item"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElIcon), { size: "25" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Message))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "hidden"])
        ])
      ]),
      _: 1
    }, 8, ["content"]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (isShow.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("站内信")), 1),
                _createElementVNode("div", _hoisted_4, [
                  (isUnRead.value)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        type: "danger",
                        class: "tag",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (clearUnRead()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("清除未读")), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        type: "info",
                        class: "tag"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("全部已读")), 1)
                        ]),
                        _: 1
                      })),
                  _createElementVNode("div", {
                    class: "clear g-flex-al-center g-pointer",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (close()))
                  }, [
                    _createVNode(_unref(ElIcon), { size: "24" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(CloseBold))
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                (isShow.value)
                  ? (_openBlock(), _createBlock(scrollArea, { key: 0 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mailList.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "item g-pt10 g-pb10 g-pr10 g-flex-al-center g-flex-jc-between g-pl10",
                            key: item.businessId
                          }, [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("img", {
                                  src: avatars[item.noticeType - 1] || avatars[4],
                                  alt: ""
                                }, null, 8, _hoisted_8)
                              ]),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, _toDisplayString(item.noticeContent), 1),
                                _createElementVNode("div", _hoisted_11, _toDisplayString(item.createDateFmt), 1)
                              ])
                            ]),
                            _createElementVNode("div", {
                              class: "del g-ml10",
                              onClick: ($event: any) => (delItem(item, index))
                            }, _toDisplayString(_ctx.$t("删除")), 9, _hoisted_12)
                          ]))
                        }), 128)),
                        (loading.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t("正在加载")) + "... ", 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_14, [
                          (noMore.value && mailList.value.length > 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t("没有更多了")), 1))
                            : _createCommentVNode("", true),
                          (noMore.value && mailList.value.length <= 0)
                            ? (_openBlock(), _createBlock(_component_el_empty, {
                                key: 1,
                                image: _unref(emptyUrl),
                                description: _ctx.$t('暂无内容')
                              }, null, 8, ["image", "description"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 32))
}
}

})